import React from "react";

interface IIconButtonProps {
  icon: React.ReactNode;
  onClick: () => void;
  type?: "button" | "submit";
  variant?: "danger" | "primary" | "secondary";
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

const IconButton: React.FC<IIconButtonProps> = ({
  icon,
  onClick,
  type = "button",
  variant = "danger",
  disabled = false,
  className = "",
  ariaLabel,
}) => {
  const variantStyles = {
    danger: "text-red-500 hover:text-red-700",
    primary: "text-blue-500 hover:text-blue-700",
    secondary: "text-gray-500 hover:text-gray-700",
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!disabled) {
      onClick();
    }
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`p-2 flex-shrink-0 transition-colors ${variantStyles[variant]} ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
    >
      {icon}
    </button>
  );
};

export default IconButton;

